import React from "react";
import ESPServiceRequestGrid from "../../components/EServicePartnerServiceRequests/ESPServiceRequestGrid";
import ESPNavbar from "./ESPNavbar";
import { useState } from "react";
import api from "../../utils/api";
import close_modal from '../../assets/ic_close_wh.svg'
import { Button } from "../../common/Button/Button";
import { getUser } from "../../utils/localStorage";
import { useEffect } from "react";
import { useLayoutEffect } from "react";
import ConfirmationModalSmall from "../../components/ServicePackaging/ConfirmationModalSmall";
import { ControlledInput } from "../../common/Input/Input";
import { toast } from "react-toastify";
import find from "lodash/find";
import Spinner from "../../common/Spinner/Spinner";
import { getESPUser } from "../../utils/localStorage";
// import { getUser } from "../../utils/localStorage";
import { storeESPSendSMSDetails } from "../../utils/localStorage";
import { getESPSendSMSDetails } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import ESPReportsModal from "../../components/EServicePartnerServiceRequests/ESPReportsModal";
import { SELECTED_SIDE_BAR_ITEM_KEY } from "../../common/SidebarContent/SidebarContent";
import DePrenuerListingDetailsModal from "../../components/EServicePartnerServiceRequests/DePrenuerListingDetailsModal.jsx";
import EditDeprenuerListingDetailsModal from "../../components/EServicePartnerServiceRequests/EditDeprenuerListingDetailsModal";
import MarkVerifiedBusinessModel from "../../components/EServicePartnerServiceRequests/MarkVerifiedBusinessModel";
import ESPCustomerFeedback from "../../components/EServicePartnerServiceRequests/ESPCustomerFeedback.jsx"
import CustomerFeedbackContainer from "./CustomerFeedbackContainer";
import Checkbox from "../../common/Checkbox/Checkbox";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import moment from "moment";
import RefundModal from "../../components/ServiceRequests/Facilitator/RefundModal";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import ESPCustomerFeedbackGrid from "../../components/EServicePartnerServiceRequests/ESPCustomerFeedbackGrid.jsx";

export default function ESPUMCFeedbackContainer(props) {
    const history = useHistory();    
    return (
        <>
            {
                <div className={`spled-container`}>
                    {
                        <ESPCustomerFeedbackGrid />
                    }
                </div>
            }

        </>
    );
}